module.exports = __webpack_public_path__ + "img/full6-min.f34cbe6d.png";